import { render, staticRenderFns } from "./LeadListTable.vue?vue&type=template&id=70e95023&scoped=true&lang=html&"
import script from "./LeadListTable.vue?vue&type=script&lang=js&"
export * from "./LeadListTable.vue?vue&type=script&lang=js&"
import style0 from "./LeadListTable.vue?vue&type=style&index=0&id=70e95023&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e95023",
  null
  
)

export default component.exports